import { Route, Redirect, RouteProps } from 'react-router-dom';

import { ROUTES } from '../../app/constants';
import { useEmbedMode } from '../embed-mode';

export const ProtectedRoute = (props: RouteProps) => {
  const { shouldInitializeApplications } = useEmbedMode();

  if (shouldInitializeApplications) {
    if (props.path === ROUTES.EMBED) {
      return <Redirect to={ROUTES.MARKETPLACE} />;
    } else {
      return <Route {...props} />;
    }
  } else {
    return <Redirect to={ROUTES.EMBED} />;
  }
};
